import gsap from 'gsap';

export default class Cta {
    constructor() {
        const ctas = document.querySelectorAll('.cta');
        Array.from(ctas).forEach( cta => {
            gsap.to(
                cta.children[0],
                {
                    scrollTrigger: {
                        trigger: cta
                    },
                    ease: "none",
                    duration: .3,
                    scale: 1
                }
            );
            gsap.to(
                cta.children[1],
                {
                    scrollTrigger: {
                        trigger: cta
                    },
                    ease: "none",
                    duration: .15,
                    scale: 1,
                    delay: .3
                }
            );
            gsap.to(
                cta.children[2],
                {
                    scrollTrigger: {
                        trigger: cta
                    },
                    ease: "none",
                    duration: .3,
                    scale: 1,
                    delay: .45
                }
            );
            gsap.to(
                cta.children[3],
                {
                    scrollTrigger: {
                        trigger: cta
                    },
                    ease: "none",
                    duration: .15,
                    scale: 1,
                    delay: .75
                }
            );
        });
    }
}